module.exports = __webpack_public_path__ + "img/pro_two_6.92c88cc4.jpg";